import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '../../../../models/user.model';
import { PerformanceEditDTO } from '../../performance-crew-planning-dto.model';

@Component({
    selector: 'app-performance-crew-field',
    templateUrl: './performance-crew-field.component.html',
    styleUrls: ['./performance-crew-field.component.scss'],
    standalone: false
})
export class PerformanceCrewFieldComponent {

    @Input() public crewMember: User | null = null;
    @Input() public earlyShift: boolean = false;
    @Input() public users: User[] = [];
    @Input() public isEditing: boolean = true;

    @Output() updateCrewMemberId: EventEmitter<number> = new EventEmitter<number>();
    @Output() updateEarlyShift: EventEmitter<boolean> = new EventEmitter<boolean>();

    protected performanceCrewPlanningDTO: PerformanceEditDTO = new PerformanceEditDTO();

    public setCrewMember($event: any): void {
        const newId = $event.target.value;
        this.updateCrewMemberId.emit(newId);
    }

    public setEarlyShift($event: any): void {
        const newValue = $event.target.checked;
        this.earlyShift = newValue;
        this.updateEarlyShift.emit(newValue);
    }
}
